// The collection grid's paging constants, shared by both the REST and GraphQL
// paths and by the page component. Extracted from the GraphQL universal load
// when the REST sibling became a second consumer — the same move the editions
// gallery made.
//
// This module imports nothing on purpose. Both loaders and the page component
// read it, and a constants file that pulled in a component would put the
// component earlier in the import graph than its own mocks, which is how the
// editions gallery spec hit a circular-initialisation error.
export const PRIMARY_GALLERY_STALE_TIME = 1000 * 60 * 60;
export const PRIMARY_GALLERY_LIMIT = 48;
